import { setIsOverlayLogin, useAppDispatch, useTranslation } from "@next-platform/client-common-core";
import { Button, ButtonSize, ButtonVariant, Image } from "@next-platform/client-common-spicy-ui";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import Trans from "@/components/Trans/Trans";
import { NSFW_BLUR_IMAGE, ROUTES } from "@/constants";
import useAuth from "@/services/useAuth";
import { cn } from "@/utils";

interface IImageThumbnailBlurredProps {
  index?: number;
  isDragging?: boolean;
  onImageSelect?: (index: number) => void;
  isSelected?: boolean;
  variant?: "conversation" | "avatar-generator";
  hideCta?: boolean;
}

const ImageThumbnailBlurred = ({
  index = 0,
  isDragging = false,
  onImageSelect = () => {},
  isSelected = false,
  variant = "avatar-generator",
  hideCta = false,
}: IImageThumbnailBlurredProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const dispatch = useAppDispatch();

  const onClickImage = useCallback(() => {
    if (!isSelected) {
      onImageSelect?.(index);
    }
  }, [isSelected, onImageSelect, index]);

  const onClickButton = useCallback(() => {
    if (isAuthenticated) {
      navigate(ROUTES.ageVerification);
    } else {
      dispatch(setIsOverlayLogin(true));
    }
  }, [isAuthenticated, navigate, dispatch]);

  return (
    <div
      data-testid="ImageThumbnailBlurred"
      className={cn("relative", variant === "avatar-generator" ? "w-[154px] h-[200px] md:w-[240px] md:h-[312px]" : "w-[378px] h-[378px] ")}
    >
      <Image
        src={NSFW_BLUR_IMAGE}
        alt={t("common:modal.generateAvatar.imageAlt.nsfwBlur")}
        className={cn(
          "cursor-pointer static rounded-md",
          variant === "avatar-generator" ? "w-[154px] h-[200px] md:w-[240px] md:h-[312px] rounded-md mt-1 ml-1" : "w-[378px] h-[378px] rounded-lg ",
          isSelected && "outline outline-2 outline-blue-500",
          isDragging ? "cursor-grabbing" : "cursor-pointer",
        )}
        onClick={onClickImage}
        draggable={false}
      />
      {!hideCta && (
        <Button
          variant={ButtonVariant.INVERSE}
          size={ButtonSize.LARGE}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          onClick={onClickButton}
        >
          {isAuthenticated ? <Trans i18nKey="common:modal.generateAvatar.gallery.cta.verifyAge" /> : <Trans i18nKey="common:createFreeAccount" />}
        </Button>
      )}
    </div>
  );
};

export default ImageThumbnailBlurred;
